<template>
  <div class="popover-box" :class="{'istopiclist': istopiclist===1}">
    <div class="p-b-inner">
      <div class="p-b-i-top">
        {{popoverContent}}
      </div>
      <div class="p-b-i-bottom" >
        <div class="p-b-i-b-ensure openappAndroidwx wx-launch-app-btn-parent">
          确定
        </div>
        <div @click="clickCancel()">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import utils from '../tool/utils'

  export default {
    name: 'Popover',
    props: ['appName', 'istopiclist', 'topicInfo'],
    data () {
      return {
        popoverContent: this.istopiclist === 1 ? `请前往${this.appName}APP进行评论` : `前往${this.appName}APP查看完整话题，体验更加`
      }
    },
    watch: {
      appName (newValue, oldValue) {
        this.appName = newValue
        this.popoverContent = this.istopiclist === 1 ? `请前往${this.appName}APP进行评论` : `前往${this.appName}APP查看完整话题，体验更加`
      }
    },
    mounted () {
      const _this = this
      $('body').css({overflow: 'hidden'})
      let _shareData = {
        ti: document.title || '',
        aid: _this.$route.params.discussID || _this.$route.params.topicID,
        ty: _this.$route.params.discussID ? '105' : '104',
        id: _this.$route.params.discussID || _this.$route.params.topicID,
        sid: _this.$route.params.sid
      }
      utils.wxLaunchChange('.p-b-i-bottom', _this.clickEnsure, '', 1, '47px', _shareData, function () {
        setTimeout(function () {
          $('body').css({overflow: 'initial'})
          if (_this.istopiclist === 1) {
            _this.$emit('showPopover', 1)
          } else {
            _this.$emit('openTopic', 0)
          }
        }, 200)
      })
    },
    methods: {
      clickEnsure: function () {
        var _this = this
        setTimeout(function () {
          $('body').css({overflow: 'initial'})
          if (_this.istopiclist === 1) {
            _this.$emit('showPopover', 1)
          } else {
            _this.$emit('openTopic', 0)
          }
        }, 200)
        this.$emit('openAppOrTopic')
        this.$emit('topicToApp')
      },
      clickCancel: function () {
        $('body').css({overflow: 'initial'})
        var _this = this
        if (_this.istopiclist === 1) {
          this.$emit('showPopover', 1)
        } else {
          _this.$router.push({
            name: 'topicColumn',
            param: {
              sid: this.$route.params.sid,
              topicID: this.$route.params.topicID,
              topicInfo: this.topicInfo
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .popover-box {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
  }

  .p-b-inner {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 5.32rem;
    height: 3.57rem;
    background: #ffffff;
    border-radius: 0.08rem;
  }

  .p-b-i-top {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.62rem;
    padding: 0.5rem;
    border-bottom: 0.01rem solid #E3E3E3;
    font-size: 0.34rem;
    line-height: 0.6rem;
    text-align: center;
    color: #333333;
  }

  .p-b-i-bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 0.94rem;
    line-height: 0.94rem;
    font-size: 0.32rem;
    color: #999999;
  }

  .p-b-i-bottom div {
    width: 50%;
    text-align: center;
  }

  .p-b-i-b-ensure {
    border-right: 0.01rem solid #E3E3E3;
    color: var(--themeColor);
  }

  .p-opreate {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .istopiclist .p-b-inner {
    height: 3rem;
  }

  .istopiclist .p-b-i-top {
    height: 2.05rem;
  }
</style>



// WEBPACK FOOTER //
// Popover.vue?0c0dd0fa